import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { RingExpandAnimation } from '../blasts/RingExpand';

registerCollisionAnimation('ELASTIC_RING', (ctx, e, config, progress) => {
  RingExpandAnimation(ctx, e as any, config, progress);
});
